import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { isMobile } from '@/common/utils/ua';
import { globalMeeting } from '@/common/utils/env';

function App() {
  const { t } = useTranslation();

  return (
    <>
      <div
        className='flex h-screen w-screen flex-col items-center bg-cover bg-fixed bg-center bg-no-repeat'
        style={{ backgroundImage: `url(${require('@/common/basis/assets/bg.png')})` }}
      >
        <div
          className={`relative mx-auto w-screen flex-1 overflow-hidden bg-white bg-contain bg-bottom bg-no-repeat ${
            isMobile ? '' : 'my-5 max-w-[473px] rounded-[24px]'
          }`}
          style={{ backgroundImage: `url(${require('@/common/basis/assets/schema_pic.png')})` }}
        >
          <div className='relative z-10 m-auto mt-20 text-center'>
            <div className='text-center'>
              <img
                className={`m-auto block ${isMobile ? 'w-[70px]' : 'w-[70px]'}`}
                src={
                  globalMeeting?.image?.logo
                    ? globalMeeting.image.logo
                    : require('@/common/basis/assets/app_logo_icon.png')
                }
              />
            </div>
            <div className='mt-4'>
              <span className={`text-[#263238] ${isMobile ? 'text-[16px]' : 'text-[22px]'}`}>
                {globalMeeting?.appName ? globalMeeting?.appName : t('appName')}
              </span>
            </div>
            <div className='mt-4'>
              <Button disabled>{t('pcEntryLook')}</Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default App;
